'use strict';

import {isMobile, projectMode, settingsData, TRoot} from "../../../settings";
import {BaseElement} from "../../interfaces/BaseElement";
import gsap from 'gsap';
import {isOptionsCardOpened, setCSSVar} from "../../../functions";

export class CylinderControlPanel {
  static #element = null;
  static #backButton = null;
  static #activeButtons = [
      'back'
  ];
  constructor() {
    if (CylinderControlPanel.#element || !isMobile)
      return;

    CylinderControlPanel.#element = new BaseElement()
      .addClass('cylinder-control-panel')
      .appendTo(TRoot);
    CylinderControlPanel.#addButtons();
    CylinderControlPanel.updateWidthCssVar();
  }

  static #addButtons() {
    CylinderControlPanel.#createButtons();
    CylinderControlPanel.#addListenersToButtons();
    CylinderControlPanel.#addIconsToButtons();
  }

  static updateWidthCssVar() {
    if (!isMobile)
      return;

    setCSSVar('--cylinderControlPanelWidth', `${parseInt(CylinderControlPanel.#width)}px`);
  }

  static #createButtons() {
    CylinderControlPanel.#backButton =
        CylinderControlPanel.#activeButtons.includes('back') && new CylinderControlPanelButton('Back')
      .appendTo(CylinderControlPanel.#element.DOMElement);
  }

  static #addListenersToButtons() {
    CylinderControlPanel.#backButton && CylinderControlPanel.#backButton.event('click', CylinderControlPanel.#backButtonHandler);
  }

  static #addIconsToButtons() {
    CylinderControlPanel.#backButton && new BaseElement('span')
      .addClass('cylinder-control-panel__button-icon', 'icon-back')
      .appendTo(CylinderControlPanel.#backButton.DOMElement);
  }

  static async #backButtonHandler() {
    if (settingsData.buildingDestroyed)
      await projectMode.FloorPlan.exitFromMode();

    CylinderControlPanel.update();
  }

  static update() {
    if (!CylinderControlPanel.#element)
      return;

    const optionsCard = Boolean(document.querySelector('.options-card'));
    if (optionsCard) {
      CylinderControlPanel.#element.addClass('hidden');
      return;
    } else {
      CylinderControlPanel.#element.removeClass('hidden');
    }
    if (settingsData.buildingDestroyed) {
      CylinderControlPanel.showButton(CylinderControlPanel.#backButton);
    } else {
      CylinderControlPanel.hideButton(CylinderControlPanel.#backButton);
    }

    CylinderControlPanel.updateWidthCssVar();
  }

  static remove() {
    if (!CylinderControlPanel.#element)
      return;

    CylinderControlPanel.#element.remove();
    CylinderControlPanel.#element = null;
  }

  static get #width() {
    return CylinderControlPanel.#element.DOMElement.getBoundingClientRect().width;
  }

  static showButton(button) {
    // if (typeof button === 'string') {
    //     switch(button) {
    //       case 'key-plan':
    //         button = CylinderControlPanel.#keyplanButton;
    //         break;
    //       default:
    //         button = undefined;
    //         break;
    //     }
    // }

    if (!button || !button.DOMElement.classList.contains('hidden'))
      return;

    gsap.fromTo(
      button.DOMElement,
      {x: 200},
      {
        x: 0,
        duration: settingsData.animationsDuration,
        onStart: () => {
          button.removeClass('hidden');
        }
      }
    );
  }

  static hideButton(button) {
    // if (typeof button === 'string') {
    //   switch(button) {
    //     case 'key-plan':
    //       button = CylinderControlPanel.#keyplanButton;
    //       break;
    //     default:
    //       button = undefined;
    //       break;
    //   }
    // }

    if (!button || button.DOMElement.classList.contains('hidden'))
      return;

    gsap.fromTo(
      button.DOMElement,
      {x: 0},
      {
        x: 200,
        duration: settingsData.animationsDuration,
        onComplete: () => {
          button.addClass('hidden');
        }
      }
    );
  }

  static hide() {
    if (!Boolean(CylinderControlPanel.#element))
      return;

    CylinderControlPanel.#element.addClass('hidden');
  }

  static show() {
    if (!Boolean(CylinderControlPanel.#element) || isOptionsCardOpened())
      return;

    CylinderControlPanel.#element.removeClass('hidden');
  }
}